
export default {
    getComments: (state) => state.comments,
}